import React from 'react';

const Email: React.FC = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="120"
      height="80"
      viewBox="0 0 120 80"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M89.9701 37.1325C92.1858 38.7206 92.1987 42.0113 89.9955 43.6166L56.8083 67.7977C55.4138 68.8138 53.5249 68.8212 52.1225 67.816L32.7469 53.9286C30.5312 52.3405 30.5184 49.0498 32.7217 47.4445L65.9088 23.2642C67.3033 22.2482 69.1921 22.2408 70.5945 23.2459L89.9701 37.1325Z"
        fill="#8646F2"
        stroke="#212121"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M91.5 40.5L59.693 44.3369L54.5 68.5"
        stroke="#212121"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M31.5 50.5L63.026 46.725L68 22.5"
        stroke="#212121"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M54.1935 25.2541C50.9885 16.8541 46.3635 10.8621 43.8635 11.8711C42.2375 12.5281 41.9195 15.9941 42.7735 20.6441C41.2515 19.9141 39.9705 19.7851 39.1565 20.4201C37.1265 22.0051 38.7415 27.7481 42.7465 33.5311C42.0635 33.7761 41.5415 34.1611 41.2915 34.7171C40.3995 36.6971 43.0175 39.8921 47.1375 41.8571C49.4975 42.9801 54.7755 44.7191 56.4515 41.6471C57.4255 39.8591 57.0695 36.9831 56.8145 35.0611C56.3685 31.7011 55.3945 28.4051 54.1935 25.2541Z"
        fill="white"
        stroke="#212121"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M42.7695 20.6382C42.7695 20.6382 46.7775 22.0682 51.1555 28.4132M42.7695 33.5192C42.7695 33.5192 45.7395 32.4292 50.3995 34.6882"
        stroke="#212121"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M78.5342 36.4919C77.0352 34.9489 73.2162 36.3769 70.0052 39.6799C69.3827 40.3255 68.8123 41.0193 68.2992 41.7549C67.8219 41.4879 67.322 41.2637 66.8052 41.0849C63.5852 39.9949 60.4392 40.7929 59.7772 42.8659C59.5012 43.7279 59.7212 44.6719 60.2792 45.5629C57.3562 46.3539 55.3692 47.6609 55.5132 48.8859C55.7032 50.4789 59.4202 51.3239 63.8192 50.7739C67.7362 50.2839 71.3532 48.6009 74.3992 46.0269C76.3232 44.3989 81.2102 39.2449 78.5342 36.4919Z"
        fill="white"
        stroke="#212121"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M68.2522 41.7319C68.2522 41.7319 70.1872 42.5229 71.2832 44.8359M60.2422 45.5659C60.2422 45.5659 62.5242 44.9229 65.5902 44.8379"
        stroke="#212121"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M24.5373 9.86012C23.8573 9.86012 23.2273 10.1661 22.5343 10.0751C21.7703 9.97512 21.2703 9.41713 20.6103 9.09013C19.9331 8.75595 19.1885 8.58084 18.4333 8.57812C17.6785 8.58106 16.9343 8.75617 16.2573 9.09013C15.5973 9.41713 15.0973 9.97512 14.3333 10.0751C13.6413 10.1651 13.0103 9.86012 12.3303 9.86012C10.3233 9.86012 8.69531 11.4751 8.69531 13.4671C8.69531 15.4591 10.3233 17.0741 12.3303 17.0741C13.0103 17.0741 13.6413 16.7681 14.3333 16.8591C15.0973 16.9591 15.5973 17.5171 16.2573 17.8441C16.9343 18.1781 17.6785 18.3532 18.4333 18.3561C19.1885 18.3534 19.9331 18.1783 20.6103 17.8441C21.2703 17.5171 21.7703 16.9591 22.5343 16.8591C23.2263 16.7681 23.8573 17.0741 24.5373 17.0741C26.5443 17.0741 28.1723 15.4591 28.1723 13.4671C28.1723 11.4751 26.5443 9.86012 24.5373 9.86012ZM108.06 64.0821C107.38 64.0821 106.75 64.3881 106.058 64.2971C105.293 64.1971 104.793 63.6391 104.133 63.3121C103.456 62.9782 102.712 62.8031 101.957 62.8001C101.202 62.803 100.458 62.9781 99.7813 63.3121C99.1213 63.6391 98.6213 64.1971 97.8563 64.2971C97.1653 64.3871 96.5343 64.0821 95.8543 64.0821C93.8473 64.0821 92.2193 65.6971 92.2193 67.6891C92.2193 69.6811 93.8473 71.2961 95.8543 71.2961C96.5343 71.2961 97.1643 70.9901 97.8563 71.0811C98.6213 71.1811 99.1213 71.7391 99.7813 72.0661C100.458 72.4 101.202 72.5751 101.956 72.5781C102.711 72.5753 103.456 72.4002 104.133 72.0661C104.793 71.7391 105.293 71.1811 106.058 71.0811C106.749 70.9901 107.38 71.2961 108.06 71.2961C110.067 71.2961 111.695 69.6811 111.695 67.6891C111.695 65.6971 110.067 64.0821 108.06 64.0821Z"
        fill="white"
        stroke="#212121"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default Email;
